import React from "react";
import { Col, Row } from "react-bootstrap";
import SelectObject from "./SelectObject";

interface TimeDurationProps {
  hours: number;
  setHours: any;
  minutes: number;
  setMinutes: any;
  setSaveIsEnabled: any;
  setUserToSave: any;
  disabled?: boolean;
}

const TimeDuration = ({ hours, setHours, minutes, setMinutes, setSaveIsEnabled, setUserToSave, disabled = false }: TimeDurationProps) => {
  const updateHour = (e: any) => {
    setHours(e.target.value);
    setSaveIsEnabled(true);
    setUserToSave(true);
  };

  const updateMin = (e: any) => {
    if (e.target.value < 60) {
      setMinutes(e.target.value);
    } else {
      const hours = Math.floor(e.target.value / 60);
      const mins = e.target.value % 60;

      setHours(hours);
      setMinutes(mins);
    }
    setSaveIsEnabled(true);
    setUserToSave(true);
  };

  const possibleHours: any[] = [
    { name: "0", key: "0" },
    { name: "1", key: "1" },
    { name: "2", key: "2" },
    { name: "3", key: "3" },
    { name: "4", key: "4" },
    { name: "5", key: "5" },
    { name: "6", key: "6" },
    { name: "7", key: "7" },
    { name: "8", key: "8" },
    { name: "9", key: "9" },
    { name: "10", key: "10" },
  ];
  const possibleMins: any[] = [
    { name: "0", key: "0" },
    { name: "5", key: "5" },
    { name: "10", key: "10" },
    { name: "15", key: "15" },
    { name: "20", key: "20" },
    { name: "25", key: "25" },
    { name: "30", key: "30" },
    { name: "35", key: "35" },
    { name: "40", key: "40" },
    { name: "45", key: "45" },
    { name: "50", key: "50" },
    { name: "55", key: "55" },
  ];

  return (
    <Row>
      <Col xs={4} lg={2}>
        <SelectObject
          label="Visit Hour"
          value={hours}
          options={possibleHours}
          onUpdate={(e: any) => updateHour(e)}
          skipInitialOption={true}
          disabled={disabled}
        />
      </Col>
      <Col xs={4} lg={2}>
        <SelectObject
          label="Visit Min"
          value={minutes}
          options={possibleMins}
          onUpdate={(e: any) => updateMin(e)}
          skipInitialOption={true}
          disabled={disabled}
        />
      </Col>
    </Row>
  );
};

export default TimeDuration;
